import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Contact.css';
import '../../globalcss.css';
import Navbar from '../Navbar/Navbar.js';
import Footer from '../Footer/Footer.js';
import mapimg from '../../Images/map.jpg';
import { NavLink } from 'react-router-dom';
import facebookround from '../../Images/facebookround.png';
import twitterround from '../../Images/twitterround.png';
import googleplus from '../../Images/google-plus.png';
import { Row, Col, Button, Icon, Form, Input } from 'antd';

const FormItem = Form.Item;
const { TextArea } = Input;
class Contact extends Component {

    componentDidMount() {
        // function to scrollto top
        // aradhana
        
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div className="contactsec">
                <div className="subpageheader">
                    <Row type="flex">
                        <Col span={24}>
                            <p className="subheaderheading"> Contact Us </p>
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col span={24}>
                            <ul className="breadcrumb">
                                <li>
                                    <NavLink to="/home">Home</NavLink>
                                </li>
                                <li>Contact Us</li>
                            </ul>
                        </Col>
                    </Row>
                    <div className="navbar">
                        <Navbar />
                    </div>
                </div>

                {/* contact us start */}
                <div className="contactsection">
                    <div className="container">
                        <Row type="flex" justify="center">
                            <Col lg={{ span: 8 }} xs={{ span: 24 }} className="light-gray-bg">
                                <div className="contactdetails">
                                    <Row type="flex" justify="center">
                                        <div className="displayflex">
                                            <Col span={4}>
                                                <div className="iconsec">
                                                    <Icon type="environment-o" className="violate" />
                                                </div>
                                            </Col>
                                            <Col span={20}>
                                                <p> Levante shop center<br></br>
                                                    Jamestreet, Vancouver Canada</p>
                                            </Col>
                                        </div>    
                                    </Row>
                                   
                                    <Row type="flex" justify="center">
                                        <Col span={4}>
                                            <div className="iconsec">
                                                <Icon type="phone" className="violate" />
                                            </div>
                                        </Col>
                                        <Col span={20}>
                                            <p> Phone : +12-345-678<br></br>
                                                Fax : +12-345-678</p>
                                        </Col>
                                    </Row>
                                    <div className="mb30"></div>
                                    <Row type="flex" justify="center">
                                        <Col span={4}>
                                            <div className="iconsec">
                                                <Icon type="mail" className="violate" />
                                            </div>
                                        </Col>
                                        <Col span={20}>
                                            <p>event@gmail.com<br></br>
                                                event@gmail.com</p>
                                        </Col>
                                    </Row>
                                    <div className="mb30"></div>
                                    <Row type="flex" justify="center">
                                      <Col span={24}>
                                      <div className="followus">
                                        <h4>Follow Us</h4>
                                        {/* <div className="social-links">
                                            <a href="#"><img src={fb} alt="category" /></a>
                                            <a href="#"><img src={link} alt="category" /></a>
                                            <a href="#"><img src={twitter} alt="category" className="norightmargin"/></a>
                                        </div>                                    */}
                                         <Row type="flex" justify="center">
                                            <Col span={17}>
                                              <ul className="list-inline">
                                                <li><a href="#"><img src={facebookround} alt="tapmenow" /></a></li>
                                                <li><a href="#"><img src={twitterround} alt="tapmenow" /></a></li>
                                                <li><a href="#"><img src={googleplus} alt="tapmenow" /></a></li>
                                              </ul>
                                            </Col>
                                        </Row>    
                                        </div>
                                      </Col>
                                    </Row>
                                </div>     
                            </Col>
                            <Col lg={{ span: 16 }} xs={{ span: 24 }} className="gray-bg">
                                <Row type="flex" justify="center">
                                <Col lg={{ span: 16 }} xs={{ span: 24 }}>
                                    <div className="contactForm">
                                        <h1> Contact Us </h1>
                                        <Form>
                                            <Row type="flex" justify="space-around">
                                                <Col span={11}>
                                                    <FormItem className="emailcont">
                                                    <Input placeholder="Your Name" />
                                                    </FormItem>
                                                </Col>
                                                <Col span={11}>
                                                    <FormItem className="emailcont">
                                                        <Input placeholder="Your Email" />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row type="flex" justify="space-around">
                                                <Col span={23}>
                                                    <FormItem className="emailcont">
                                                        <Input placeholder="Your Subject" />
                                                    </FormItem>
                                                    <FormItem className="emailcont">
                                                    <TextArea placeholder="Your Message" autosize={{ minRows: 6, maxRows: 6 }} />
                                                    </FormItem>
                                                    <FormItem>
                                                        <Button
                                                            type="primary"
                                                            htmlType="submit">
                                                            SEND MESSAGE
                                                        </Button>
                                                    </FormItem>
                                                </Col>
                                            </Row>     
                                            
                                        </Form>
                                    </div>
                                </Col>
                                </Row>   
                            </Col>
                        </Row>
                        <div className="contactmap">
                            <div className="mapimgsec">
                                <img className="width100" src={mapimg} alt="tapmenow" />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/Component/Contact/Contact.js